import { isArray, isString, isPlainObject } from 'lodash';

import { DEFAULT_IGNORE_TRANSFORM_KEYS } from './constant';

const trimReg = /[\u200b\u200d\u200c\u200e\u200f\ufeff]*/g;

// 去除隐藏空格
const trimZero = (str: string) => str.replace(trimReg, '');

// 转换 camelCase 为 snake_case
const localUnderScoreCase = (x: string): string => x.replace(/([A-Z])/g, '_$1').toLowerCase();

type Params = object | URLSearchParams | undefined;

/**
 * 递归地将对象的键名转换为 snake_case，并修剪字符串中的隐藏空格。
 * @param obj - 要处理的对象或数组。
 * @param excludedKeys - 不需要转换的键名数组。指定的键及其子级将跳过递归处理。
 * @returns 转换后的对象、数组或字符串。
 */
export const lowerCase = (obj?: Params, excludeTransformKeys: string[] = []): Params => {
  // 去重处理，将数组转换为 Set
  const excludedSet = new Set(excludeTransformKeys.concat(DEFAULT_IGNORE_TRANSFORM_KEYS));

  if (obj == null) {
    // 处理 undefined 或 null 的情况
    return obj;
  }

  if (isArray(obj)) {
    // 递归处理数组元素
    return obj.map((x) => lowerCase(x, excludeTransformKeys));
  }

  if (isString(obj)) {
    // 修剪字符串中的隐藏空格
    // @ts-expect-error 无法确定 obj 是 string 类型
    return trimZero(obj);
  }

  if (isPlainObject(obj)) {
    const result: Record<string, unknown> = {};

    // 处理对象的键名转换
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const child = obj[key];

        // 如果键名在排除列表中，跳过递归处理
        if (excludedSet.has(key)) {
          result[key] = child;
        } else {
          result[localUnderScoreCase(key)] = lowerCase(child as Params, excludeTransformKeys);
        }
      }
    }

    return result;
  }

  // 如果不是数组、对象或字符串，直接返回原值
  return obj;
};
